<input type="text" id="" #intlInput>
<input type="text" [value]="formattedValue" id=""  (input)="onInputChange($event)" maxlength="12" placeholder="123-456-7890">
